import { IonContent, IonPage } from '@ionic/react'
import { useMemo } from 'react'

import { Control } from '@apps-common/apps/portal/pages/units/pages/manage/components/controls/Control'
import { NoResultsCard, PullRefresh } from '@apps-common/components/common'
import { VertSpacerLg } from '@apps-common/components/layout'
import { ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { ModalDismiss } from '@apps-common/config/modal'
import { useControlsContext } from '@apps-common/contexts/ControlContext'
import { useControlTheme } from '@apps-common/hooks/useControlTheme'

export const ControlsPendingModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => {
  const { awaiting } = useControlsContext()
  const { resolve } = useControlTheme()

  const sites = useMemo(
    () =>
      awaiting
        .map((a) => a.control?.siteName)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort(),
    [awaiting]
  )

  console.log(sites)

  return (
    <ModalContainer
      innerClasses='!h-[100vh] !max-h-[100vh] !rounded-[0px] max-w-[320px] sm:max-w-[min(100%,280px)] !ml-auto !mr-0 safe-area-top safe-area-left safe-area-right'
      onDismiss={onDismiss}
    >
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader title='Pending controls' />
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <IonPage>
        <IonContent
          style={{
            '--background': 'transparent'
          }}
        >
          <div className='relative px-[20px] pt-[100px] flex flex-col gap-[0px]'>
            <PullRefresh loading={false} callback={() => {}} />
            {sites.length === 0 && <NoResultsCard>No controls pending updates.</NoResultsCard>}
            {sites.map((s, i) => {
              const controls = awaiting.filter((a) => a.control.siteName === s)

              return (
                <div className='w-full flex flex-col gap-[10px]'>
                  <div key={`controls-pending-site-${i}`} className='text-secondary-content jost-light'>
                    {s}
                  </div>
                  <VertSpacerLg />
                  <div className='flex flex-col gap-[10px]'>
                    {controls.map((a) => {
                      return (
                        <Control
                          key={`pending-control-list-item-${a.control.unitControlId}`}
                          unitStatus=''
                          isActivated={false}
                          containerClasses='w-full'
                          control={a.control}
                          idPrefix='control-pending-modal'
                        />
                      )
                    })}
                  </div>
                  <VertSpacerLg />
                  <div className='border-[1px] border-secondary-content/10' />
                  <VertSpacerLg />
                </div>
              )
            })}
            {sites.length === 0 && (
              <div className='text-secondary-content/60 uppercase flex items-center justify-center gap-[15px] text-[0.8em] my-[20px] px-[10px]'>
                <div className='h-[1px] grow bg-secondary-content/60' />
                No pending controls
                <div className='h-[1px] grow bg-secondary-content/60' />
              </div>
            )}
          </div>
        </IonContent>
      </IonPage>
    </ModalContainer>
  )
}
